export const quoteTransactionStatus = {
	pending: 'PENDING',
	missingAddress: 'MISSING_ADDRESS',
	submitted: 'SUBMITTED',
	error: 'ERROR',
} as const;
